import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/auth";
import { EtiquetaVersion } from "../components/Layout";


export default function LoginPage() {
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Error de inicio de sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-plano">
      {/* Esquina superior izquierda, igual que con la sesión iniciada: aquí no hay
          barra lateral donde leerla, y es justo donde más falta hace saber qué
          versión respondió. Fijo y sin capturar el ratón, para no estorbar. */}
      <div className="fixed top-3 left-4 text-xs text-tinta-3 pointer-events-none select-none">
        <span className="font-semibold text-tinta">Analista</span> <EtiquetaVersion />
      </div>
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-superficie border border-grid rounded-2xl shadow-sm p-8"
      >
        <div className="mb-6 text-center">
          <div className="text-2xl font-bold text-tinta">Analista</div>
          <div className="text-marca text-sm">Visor estadístico y codificación de encuestas</div>
        </div>
        <label className="etiqueta">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input mb-3"
        />
        <label className="etiqueta">Contraseña</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input mb-4"
        />
        {error && <div className="text-estado-critico text-sm mb-3">{error}</div>}
        <button
          type="submit"
          disabled={busy}
          className="btn w-full py-2"
        >
          {busy ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
